// Basic table component using react-table
import React, { useState } from "react";
import {
  useTable,
  useSortBy,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";

import { ReactComponent as DownArrow } from "images/downArrow.svg";
import { ReactComponent as UpArrow } from "images/upArrow.svg";
import { ReactComponent as DoneIcon } from "images/doneIcon.svg";
import { ReactComponent as CancelIcon } from "images/cancelIcon.svg";
import { ReactComponent as SvgAdd } from "images/svgAdd.svg";

const Table = ({
  columns = [],
  data = [],
  subTable = false,
  addNewRowButtonTitle = "",
  lockTable = false,
  AddRowComponent = () => {
    <></>;
  },
  AddNewRowFunction = () => {
    console.log("Add New Row Clicked");
  },
  CancelNewRowFunction = () => {
    console.log("Cancel New Row Clicked");
  },
}) => {
  // Sample data
  // Initial dummy data in state
  const [showAddButton, setShowAddButton] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const toggleRowExpanded = (rowId) => {
    setExpandedRows((prevState) => {
      const isCurrentlyExpanded = !!prevState[rowId];
      if (isCurrentlyExpanded) {
        // If clicking an already expanded row, collapse it (no rows expanded)
        return {};
      } else {
        // Expand only the clicked row, collapse others
        return { [rowId]: true };
      }
    });
  };

  // Create table instance
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    // setPageSize,
    // state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      //   initialState: { pageSize: perPageSize || 10 },
    },
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const addRow = () => {
    setShowAddButton(true);
  };

  return (
    <div className="w-full overflow-auto">
      <table
        {...getTableProps()}
        style={{ width: "100%", borderCollapse: "collapse" }}
        className={!subTable ? "rounded-[12px] border border-[#E4E4E7]" : ""}
      >
        <thead className="">
          {headerGroups.map((headerGroup, index) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              key={`header-${index}`}
              className="rounded-[12px] "
            >
              {headerGroup.headers.map((column, i) =>
                column?.id === "expander" ? null : (
                  <>
                    <th
                      {...column.getHeaderProps()}
                      className={`${
                        i === 0 ? "pl-[43px]" : ""
                      } h-[56px] px-[16px] py-[12px] items-center gap-[12px] border-b border-b-[#E4E4E7] bg-[#F7F8F8]`}
                      style={{ textAlign: "left" }}
                      colSpan={column.colSpan}
                    >
                      <div className="overflow-hidden  text-[#1D1B22] font-semibold text-[16px]">
                        {column.render("Header")}
                      </div>
                    </th>
                    {column?.id === "action" && (
                      <th
                        className="h-[56px] px-[16px] py-[12px] border-b border-b-[#E4E4E7] bg-[#F7F8F8]"
                        aria-label="empty"
                      />
                    )}
                  </>
                )
              )}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {addNewRowButtonTitle.length > 0 && !lockTable && (
            <tr
              className="border-b border-b-[#E4E4E7] hover:rounded-[4px] hover:bg-white hover:shadow-[0_0_15px_-2px_rgba(16,24,40,0.14)] group"
              onClick={addRow}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") addRow();
              }}
            >
              <td colSpan={data?.length + 2} className="p-0 ">
                <div className="flex h-[60px] px-[16px] py-[10px] items-center gap-[8px] cursor-pointer select-none">
                  <div className="flex w-[20px] h-[20px] justify-center items-center">
                    <SvgAdd />
                  </div>
                  <div className="overflow-hidden text-[#1D1B22] font-semibold text-[16px] ">
                    {addNewRowButtonTitle}
                  </div>
                </div>
              </td>
            </tr>
          )}
          {showAddButton && (
            <tr className="bg-[#F3F5F7] hover:border-b hover:border-b-[#D1D1D6] hover:shadow-[0_0_15px_-2px_rgba(16,24,40,0.14)]  group">
              <AddRowComponent />
              <td
                colSpan={data?.length + 1}
                className={`${"p-0 overflow-hidden text-[#1D1B22] font-semibold text-[16px] "}`}
              >
                <div
                  className="flex h-[60px] min-w-[56px] min-h-[60px] px-[16px] py-[10px] justify-end items-end gap-[12px] self-stretch
                    opacity-100 group-hover:opacity-100 transition-opacity duration-200"
                >
                  <div
                    className="flex w-[24px] h-[40px] items-center cursor-pointer"
                    onClick={() => {
                      AddNewRowFunction();
                      setShowAddButton(false);
                    }}
                  >
                    <DoneIcon />
                  </div>
                  <div
                    className="flex w-[24px] h-[40px] items-center cursor-pointer"
                    onClick={() => {
                      CancelNewRowFunction();
                      setShowAddButton(false);
                    }}
                  >
                    <CancelIcon />
                  </div>
                </div>
              </td>
            </tr>
          )}
          {page.map((row, index) => {
            prepareRow(row);
            const isExpanded = expandedRows[row.id] || false;

            return (
              <>
                <tr
                  {...row.getRowProps()}
                  className={`${
                    !subTable
                      ? `border-b border-b-[#E4E4E7] hover:rounded-[4px] ${
                          lockTable
                            ? ""
                            : "hover:bg-white hover:shadow-[0_0_15px_-2px_rgba(16,24,40,0.14)]"
                        }  group`
                      : `bg-[#F3F5F7] ${
                          lockTable
                            ? ""
                            : "hover:border-b hover:border-b-[#D1D1D6] hover:shadow-[0_0_15px_-2px_rgba(16,24,40,0.14)]"
                        }    group`
                  } `}
                  key={`row-${index}`}
                  colSpan={data?.length}
                >
                  {row.cells.map((cell, index) => {
                    if (cell.column.id === "expander" && index === 0) {
                      return null;
                    }

                    return (
                      <>
                        {cell.column.id === "action" ? (
                          <td
                            colSpan={data?.length + 1}
                            style={{
                              width: "5%",
                              maxWidth: "80px",
                              position: "relative",
                            }}
                            className="p-0 overflow-visible"
                          >
                            <div
                              className={`absolute right-0 top-0 h-full flex items-center gap-[20px] p-[20px] ${
                                !subTable
                                  ? "[background:linear-gradient(270deg,#FFF_86.21%,#E0E6EB_100%)]"
                                  : "[border-radius:0_0_4px_0] [background:linear-gradient(270deg,#F3F5F7_85.21%,#E0E6EB_100%)]"
                              } p-2 rounded shadow-lg opacity-0  group-hover:${
                                lockTable ? "" : "opacity-100"
                              } transition-opacity duration-200 z-10`}
                            >
                              {row.allCells
                                .find((cell) => cell.column.id === "action")
                                ?.column.Cell({ row })}
                            </div>
                          </td>
                        ) : (
                          <td
                            {...cell.getCellProps()}
                            className={`h-[60px] min-w-[56px] min-h-[60px] ${
                              row?.cells[0]?.column?.id === "expander" &&
                              index === 1
                                ? ""
                                : "px-[16px]"
                            } py-[10px] items-center gap-[12px] self-stretch`}
                            key={cell.column.id}
                          >
                            <div className="flex items-center overflow-hidden text-[#1D1B22] font-medium text-[16px] ">
                              {index === 1 &&
                              row?.cells[0]?.column?.id === "expander" ? (
                                <span
                                  {...row.getToggleRowExpandedProps()}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleRowExpanded(row.id);
                                  }}
                                  className={`flex cursor-pointer select-none gap-[8px] items-center py-[10px] ${
                                    !subTable ? "px-[25px]" : "px-[48px]"
                                  }`}
                                >
                                  {isExpanded ? <UpArrow /> : <DownArrow />}
                                  {cell.render("Cell")}
                                </span>
                              ) : (
                                <span
                                  className={
                                    index === 0 && subTable ? "pl-[27px]" : ""
                                  }
                                >
                                  {cell.render("Cell")}
                                </span>
                              )}
                            </div>
                          </td>
                        )}
                      </>
                    );
                  })}
                </tr>

                {isExpanded ? (
                  <tr>
                    <td colSpan={row.cells.length}>
                      {row.allCells
                        .find((cell) => cell.column.id === "expander")
                        ?.column.ExpandedRowContent({ row })}
                    </td>
                  </tr>
                ) : null}
              </>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
